import { Component, Input, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { marcHolding, marc } from 'src/app/models/walai';

@Component({
  selector: 'app-marcholding',
  templateUrl: './marcholding.component.html',
  styleUrls: ['./marcholding.component.css']
})
export class MarcholdingComponent implements OnInit {
  @Input() bibid: string;
  holdings: marcHolding[];

  constructor(private homeService: HomeService) { }

  ngOnInit(): void {
    this.homeService.getMarcHolding(this.bibid).subscribe((holdings: marcHolding[]) => {
      // Apply subfield highlighting to each MARC tag in each holding
      this.holdings = holdings.map(h => ({
        ...h,
        marcs: h.marcs.map(tag => ({
          ...tag,
          Subfield: this.highlightSubfields(tag.Subfield)
        }))
      }));
    });
  }

  copyToClipboard(): void {
    if (!this.holdings || this.holdings.length === 0) {
      return;
    }

    // Format MARC Holding data as text based on user pattern: ^\d{3}[\t].[\t].[\t].+[\n]|^\d{3}[\t].[\t].[\t].+
    let marcText = '';

    this.holdings.forEach((holding, holdingIndex) => {
      holding.marcs.forEach((tag, index) => {
        const ind1 = tag.Indicator1 && tag.Indicator1.trim() !== '' ? tag.Indicator1 : '.';
        const ind2 = tag.Indicator2 && tag.Indicator2.trim() !== '' ? tag.Indicator2 : '.';
        const subfield = this.stripHtml(tag.Subfield);

        marcText += `${tag.TagID}\t${ind1}\t${ind2}\t${subfield}`;

        // Add newline if it's not the last tag of the last holding
        if (!(holdingIndex === this.holdings.length - 1 && index === holding.marcs.length - 1)) {
          marcText += '\n';
        }
      });
    });

    // Copy to clipboard
    navigator.clipboard.writeText(marcText).then(() => {
      alert('MARC holding record copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  private stripHtml(html: string): string {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  highlightSubfields(text: string): string {
    if (!text) return '';
    // Regex to match $ followed by a character (subfield code)
    return text.replace(/\$([a-z0-9])/g, '<span class="marc-subfield-code">$$$1</span>');
  }
}
